import { buildCsv, escapeCsvField } from './downloadOriginCsv';
import {
  showsReportLayout,
  userDetailColumns,
  userPreviewColumns,
} from './downloadReportCatalog';

const APPROVE_CSV_AMOUNT_AFTER = {
  assigned: 'assigned_amount',
  approved: 'approved_amount',
  upsale: 'upsale_amount',
};

export { buildCsv, escapeCsvField };

export const userCsvFileName = (subtype, from, to) => {
  const safePart = value => String(value || '').replace(/:/g, '-');
  return `user-${safePart(subtype)}-${safePart(from)}-to-${safePart(to)}.csv`;
};

const DETAIL_TEXT_COLUMNS = new Set(['invoice_number', 'agent_name']);
const UPSALE_TEXT_COLUMNS = new Set([
  'sale_date',
  'invoice_number',
  'order_source',
  'sku',
  'product_name',
  'status',
]);

export const isUserDetailLayout = (subtype, reportLayout) =>
  reportLayout === 'details' && showsReportLayout('user', subtype);

export const userCsvColumns = (subtype, reportLayout = 'summary') => {
  if (isUserDetailLayout(subtype, reportLayout)) {
    return userDetailColumns(subtype);
  }
  const columns = userPreviewColumns(subtype);
  if (subtype !== 'cross_sale_upsale_approve') return columns;
  return columns.flatMap(column => {
    const amountKey = APPROVE_CSV_AMOUNT_AFTER[column];
    return amountKey ? [column, amountKey] : [column];
  });
};

const TEXT_COLUMNS = new Set([
  'sale_date',
  'invoice_number',
  'order_source',
  'sku',
  'product_name',
  'status',
]);

export const userCsvMetricCells = (metrics = {}, columns = []) =>
  columns.map(column => {
    if (TEXT_COLUMNS.has(column)) return metrics[column] ?? '';
    return metrics[column] ?? 0;
  });

export const userDetailCsvCells = (row = {}, columns = []) =>
  columns.map(column => {
    if (DETAIL_TEXT_COLUMNS.has(column)) return row[column] ?? '';
    return row[column] ?? 0;
  });

export const userDetailTotalsCells = (totals = {}, columns = []) =>
  columns.map((column, index) => {
    if (index === 0 || DETAIL_TEXT_COLUMNS.has(column)) return '';
    if (UPSALE_TEXT_COLUMNS.has(column)) return '';
    return totals[column] ?? 0;
  });

export const buildUserCsv = buildCsv;
